import { clog } from "./common";

// paypal_sdk object is created from the official sdk js file placed in the view _paypal_button.php

// #paypal_button is in checkout page,
// #paypal_button_1 and #paypal_button_2 are in cart page

const MAX_FIELD_LENGTH = 35;

/**
 * Restituisce la stringa pulita e troncata a maxLength caratteri.
 * Se il valore non esiste (PayPal omette i campi vuoti), non è una stringa
 * o contiene solo spazi, restituisce ''.
 */
function clip(value, maxLength) {
    if (typeof value !== 'string') {
        return '';
    }
    const trimmed = value.trim();
    return maxLength ? trimmed.slice(0, maxLength) : trimmed;
}

/**
 * Legge il valore di un campo del form in modo sicuro:
 * se il campo non esiste o il valore è null/undefined restituisce ''.
 */
function fieldVal(selector) {
    const val = $(selector).val();
    return typeof val === 'string' ? val.trim() : '';
}

function showLoading(show) {
    const el = document.getElementById('loading-bodyclick');
    if (el) {
        el.style.display = show ? 'block' : 'none';
    }
}

['#paypal_button', '#paypal_button_1', '#paypal_button_2'].forEach(function (selector) {
    if ($(selector).length > 0) {

        paypal_sdk.Buttons({
            style: paypal_style,

            onClick: function () {
                if (typeof window.trackInitiateCheckout === 'function') {
                    window.trackInitiateCheckout();
                }
            },

            createOrder: function (data, actions) {
                // This function sets up the details of the transaction, including the amount and line item details.
                return actions.order.create({
                    purchase_units: paypal_purchase_units
                });
            },

            onApprove: function (data, actions) {

                // if normal checkout, do not ask the customer to double check again the shipping address
                if (selector == '#paypal_button') {
                    showLoading(true);

                    // This function captures the funds from the transaction.
                    return actions.order.capture().then(function (details) {
                        clog("paypal_transaction_ok", details);

                        $.ajax({
                            contentType: 'application/json',
                            data: JSON.stringify({ details }),
                            dataType: 'json',
                            processData: false,
                            type: 'POST',
                            url: paypal_confirm_url,
                            success: function (data) {
                                if (data.status == 'ok') {
                                    window.location.href = data.redirect_url;
                                } else {
                                    clog("paypal_transaction_ok_not_received_1", { data: data, details: details });
                                    alert("There was an error with your order. Please try again or contact us.");
                                    location.reload();
                                }
                            },
                            error: function (error) {
                                clog("paypal_transaction_ok_not_received_2", { error: error, data: details });
                                alert("There was an error with your order. Please try again or contact us.");
                                location.reload();
                            }
                        });
                    });
                }
                // if express checkout, ask the customer to double check his shipping address
                else {
                    // recuperiamo i dettagli dell'ordine SENZA catturare
                    return actions.order.get().then(function (orderData) {

                        // salva actions per usarla dopo
                        window._paypalActions = actions;
                        window._paypalOrderData = orderData;

                        // precompila il form: un eventuale errore NON deve impedire l'apertura del popup
                        try {
                            const pu = orderData && orderData.purchase_units && orderData.purchase_units[0];
                            populateAddressPopup(pu && pu.shipping ? pu.shipping : null);
                        } catch (e) {
                            clog("paypal_populate_error", { error: e && e.message, orderData: orderData });
                        }

                        // mostra popup
                        $('.address-confirmation-overlay')
                            .removeClass('hidden')
                            .addClass('active');

                        $('#address-confirmation-modal')
                            .removeClass('hidden')
                            .addClass('active');

                        $('body').addClass('modal-open');
                    });
                }
            },

            onCancel: function (data) {
                // Show a cancel page, or return to cart
                location.reload();
            },

            onError: function (err) {
                showLoading(false);
                clog("paypal_transaction_error", err);
            }

        }).render(selector);
    }
});

function populateAddressPopup(shipping) {

    if (!shipping || !shipping.address) {
        return;
    }

    const addr = shipping.address;

    // Nome completo PayPal → separazione base
    let firstName = '';
    let lastName = '';

    const fullName = clip(shipping.name && shipping.name.full_name);
    if (fullName) {
        const parts = fullName.split(/\s+/);
        firstName = parts.shift();
        lastName = parts.join(' ');
    }

    // Campi indirizzo: primi 35 caratteri, '' se PayPal non li manda
    const address = clip(addr.address_line_1, MAX_FIELD_LENGTH);
    const other_information = clip(addr.address_line_2, MAX_FIELD_LENGTH);
    const city = clip(addr.admin_area_2, MAX_FIELD_LENGTH);
    const postalCode = clip(addr.postal_code);

    // update country dropdown
    const countryCode = clip(addr.country_code);
    if (countryCode) {
        const $countrySelect = $('#paypal-country');
        const $matchingOption = $countrySelect.find(
            'option[data-country-code="' + countryCode + '"]'
        );
        if ($matchingOption.length > 0) {
            $countrySelect.val($matchingOption.val());
        }
    }

    // Popolamento campi
    $('#paypal-first_name').val(firstName);
    $('#paypal-last_name').val(lastName);
    $('#paypal-address').val(address);
    $('#paypal-shipping_other_information').val(other_information);
    $('#paypal-city').val(city);
    $('#paypal-postal_code').val(postalCode);
}

$('.paypal-confirm_address').on('click', function (e) {

    e.preventDefault();

    // Rimuove errori precedenti
    $('.error').removeClass('error');
    $('.field-error-message').remove();

    let hasError = false;

    function validateField(selector) {
        const field = $(selector);

        if (!fieldVal(selector)) {
            field.addClass('error');
            if (!hasError && field[0]) {
                field[0].scrollIntoView({ behavior: "smooth", block: "center" });
            }
            hasError = true;
        }
    }

    // Campi obbligatori
    validateField('#paypal-first_name');
    validateField('#paypal-last_name');
    validateField('#paypal-address');
    validateField('#paypal-city');
    validateField('#paypal-postal_code');
    validateField('#paypal-country');

    if (hasError) {
        return;
    }

    if (!window._paypalActions) {
        clog("paypal_express_missing_actions", {});
        alert("There was an error with your payment. Please try again.");
        location.reload();
        return;
    }

    // Mostra loading SOLO se validazione OK
    showLoading(true);

    // Rilettura dal form (l'utente può aver modificato i campi): di nuovo max 35 caratteri
    const customAddress = {
        first_name: fieldVal('#paypal-first_name'),
        last_name: fieldVal('#paypal-last_name'),
        company: fieldVal('#paypal-company'),
        address: fieldVal('#paypal-address').slice(0, MAX_FIELD_LENGTH),
        city: fieldVal('#paypal-city').slice(0, MAX_FIELD_LENGTH),
        postal_code: fieldVal('#paypal-postal_code'),
        country_id: fieldVal('#paypal-country'),
        other_information: fieldVal('#paypal-shipping_other_information').slice(0, MAX_FIELD_LENGTH),
        telephone: fieldVal('#paypal-telephone'),
    };

    window._paypalActions.order.capture().then(function (details) {

        clog("paypal_express_transaction_ok", details);

        $.ajax({
            url: paypal_confirm_url,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            processData: false,
            data: JSON.stringify({
                details: details,
                custom_address: customAddress
            }),
            success: function (data) {
                if (data.status === 'ok') {
                    window.location.href = data.redirect_url;
                } else {
                    clog("paypal_express_not_received_1", { data: data, details: details, address: customAddress });
                    alert("There was an error with your order. Please contact us.");
                    location.reload();
                }
            },
            error: function (err) {
                clog("paypal_express_not_received_2", { error: err, details: details, address: customAddress });
                alert("There was an error with your order. Please contact us.");
                location.reload();
            }
        });

    }).catch(function (err) {
        showLoading(false);
        clog("paypal_express_capture_error", err);
        alert("The payment could not be completed. Please try again.");
        location.reload();
    });
});

$('#address-confirmation-modal input, #address-confirmation-modal select').on('input change', function () {
    const val = $(this).val();
    if (typeof val === 'string' && val.trim() !== '') {
        $(this).removeClass('error');
        $(this).next('.field-error-message').remove();
    }
});

$('.address-confirmation-overlay').on('click', function () {
    $(this).removeClass('active').addClass('hidden');
    $('#address-confirmation-modal').removeClass('active').addClass('hidden');
    $('body').removeClass('modal-open');
});